import styled from 'styled-components';

import { BaseStyledComponentProps, StyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface TableCellProps extends BaseStyledComponentProps {
	as: string;
	hasImage: boolean;
}

interface TableCellTitleProps {
	as: string;
}

const StyledTable = styled('table')`
	width: 100%;
	border-collapse: collapse;
	color: ${({ theme }: BaseStyledComponentProps) => hexToRgba(theme.primary.strongColor, 70)};
`;

const TableCellInner = styled('div')`
	display: flex;
	align-items: center;
`;

const TableCellImageWrapper = styled('div')`
	width: 125px;
	height: 125px;
	border: 1px solid ${({ theme }: BaseStyledComponentProps) => hexToRgba(theme.primary.strongColor, 9)};
	border-radius: 9px;
	background-color: ${StyleColor.White};
	box-shadow: 0 0 22px -8px ${({ theme }: BaseStyledComponentProps) => hexToRgba(theme.primary.strongColor, 17)};
	overflow: hidden;
`;

const TableCellImage = styled('img')`
	width: 100%;
`;

const TableCellButton = styled('button').attrs({
	type: 'button',
})`
	width: 34px;
	height: 34px;
	padding: 8px;
	border: 0;
	border-radius: 4px;
	outline: 0;
	background-color: ${({ theme }: BaseStyledComponentProps) => hexToRgba(theme.primary.actionColor, 10)};
	color: ${({ theme }: BaseStyledComponentProps) => theme.primary.actionColor};
	cursor: pointer;

	& + & {
		margin-left: 4px;
	}

	&:hover {
		background-color: ${({ theme }: BaseStyledComponentProps) => theme.primary.actionColor};
		color: ${StyleColor.White};
	}

	svg {
		width: 100%;
		height: 100%;
		fill: currentColor;
	}
`;

const TableCellTitle = styled('textarea')`
	flex: 1 1 50%;
	margin-left: 30px;
	padding: 10px;
	font-size: 17px;
	line-height: 20px;
	color: ${({ theme }: BaseStyledComponentProps) => theme.primary.strongColor};
	border: 1px solid transparent;
	border-radius: 4px;
	background-color: transparent;

	${(props: TableCellTitleProps) => props.as === 'textarea' && `
		width: 100%;
		min-height: 40px;
		font-family: inherit;
		outline: 0;
		resize: none;
		-webkit-appearance: none;

		&:focus {
			background-color: ${({ theme }: BaseStyledComponentProps) => hexToRgba(theme.primary.strongColor, 3)};
			border-color: currentColor;
		}
	`}
`;

const TableCell = styled('td')`
	box-sizing: border-box;
	position: relative;
	width: 15%;
	height: ${({ as, hasImage }: TableCellProps) => {
		if (as === 'th') {
			return '30px';
		}
		return hasImage ? '157px' : '60px';
	}};
	padding: 15px;
	text-align: left;

	&:first-child {
		width: 60%;
	}

	&::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		border-bottom: 1px solid ${({ theme }: TableCellProps) => hexToRgba(theme.primary.strongColor, 9)};

		tbody tr:last-child & {
			border: 0;
		}
	}

	${({ as, theme }: TableCellProps) => as === 'th' && `
		position: sticky;
		top: 0;
		z-index: 1;
		background-color: ${theme.primary.backgroundColor};
		font-weight: 400;
		font-size: 11px;
		line-height: 12px;
		color: ${theme.primary.actionColor};
	`}

	// mobile
	@media only screen and (max-width : 600px) {
		vertical-align: ${({ as }: TableCellProps) => as === 'th' ? 'middle' : 'top'};

		&:nth-child(2),
		&:last-child {
			display: none;
		}

		${TableCellTitle} {
			margin-left: 10px;
		}

		${TableCellImageWrapper},
		${TableCellButton} {
			margin-top: 10px;
		}

		${({ as }: TableCellProps) => as === 'th' && `
			&:first-child span:first-child {
				display: none;
			}
		`}
	}

	// tablet + desktop
	@media only screen and (min-width : 601px) {
		&:first-child ${TableCellImageWrapper} {
			display: none;
		}

		&:nth-child(3) ${TableCellInner} {
			display: none;
		}

		${({ as }: TableCellProps) => as === 'th' && `
			&:first-child span:last-child {
				display: none;
			}
		`}
	}
`;

export {
	StyledTable,
	TableCell,
	TableCellInner,
	TableCellImageWrapper,
	TableCellImage,
	TableCellButton,
	TableCellTitle,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotesPage/Table/styles.ts